import React, { createContext, useContext, useState } from 'react';

interface MobileMenuContextType {
  isMainMenuOpen: boolean;
  setIsMainMenuOpen: (open: boolean) => void;
}

const MobileMenuContext = createContext<MobileMenuContextType | undefined>(undefined);

export function MobileMenuProvider({ children }: { children: React.ReactNode }) {
  const [isMainMenuOpen, setIsMainMenuOpen] = useState(false);

  return (
    <MobileMenuContext.Provider value={{ isMainMenuOpen, setIsMainMenuOpen }}>
      {children}
    </MobileMenuContext.Provider>
  );
}

export function useMobileMenu() {
  const context = useContext(MobileMenuContext);
  if (context === undefined) {
    throw new Error('useMobileMenu must be used within a MobileMenuProvider');
  }
  return context;
}
